export default {
  chiSiamo: 'About us',
  organizzazione: 'Structure',
  welfare: 'Welfare & Wellbeing',
  selezione: 'Recruitment',
  talentDay: 'Talent Day',
}
